import script from "./ServiceAgreementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceAgreementModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceAgreementModal.vue?vue&type=style&index=0&id=f226996c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f226996c"]])

export default __exports__